// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page .card {
  align-items: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  text-align: center;
  background-color: #f5fbff !important;
  border: none;
  box-shadow: none;
}
.about-page .card .btn-link {
  padding-top: 10px;
}
.about-page .card h2 {
  margin-bottom: 20px;
}
.about-page .card p {
  margin-bottom: 0;
}
.about-page .card .email {
  height: 39px;
  width: 315px;
}
.about-page .bottom {
  text-align: center;
}

.about-header {
  width: auto;
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #414b4f;
}

.about-summary {
  width: auto;
  height: auto;
  flex-grow: 0;
  margin: 16.7px 0 0;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #414b4f;
}

.btn-about {
  width: auto;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 8px 30px;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(10, 69, 91, 0.26);
  background-color: #00889b;
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/acds-about/AboutPage.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AAGI;EACE,mBAAA;AADN;AAII;EACE,gBAAA;AAFN;AAKI;EACE,YAAA;EACA,YAAA;AAHN;AAOE;EACE,kBAAA;AALJ;;AASA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;EACA,yBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AANF","sourcesContent":[".about-page {\n  .card {\n    align-items: center;\n    margin-bottom: 40px;\n    padding-bottom: 20px;\n    text-align: center;\n    background-color: #f5fbff !important;\n    border: none;\n    box-shadow: none;\n\n    .btn-link {\n      padding-top: 10px;\n    }\n  \n    h2 {\n      margin-bottom: 20px;\n    }\n  \n    p {\n      margin-bottom: 0;\n    }\n\n    .email {\n      height: 39px;\n      width: 315px;\n    }\n  }\n\n  .bottom {\n    text-align: center;\n  }\n}\n\n.about-header {\n  width: auto;\n  flex-grow: 0;\n  font-family: 'Open Sans';\n  font-size: 20px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: center;\n  color: #414b4f;\n}\n\n.about-summary {\n  width: auto;\n  height: auto;\n  flex-grow: 0;\n  margin: 16.7px 0 0;\n  font-family: 'Open Sans';\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: center;\n  color: #414b4f;\n}\n\n.btn-about {\n  width: auto;\n  height: 40px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 30px;\n  border-radius: 4px;\n  box-shadow: 0 4px 8px 0 rgba(10, 69, 91, 0.26);\n  background-color: #00889b;\n  flex-grow: 0;\n  font-family: 'Open Sans';\n  font-size: 16px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: center;\n  color: #ffffff;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
